var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-layout"},[_c('newHeader',{staticClass:"new-header"}),_c('div',{staticClass:"content"},[(_vm.showSidebar)?_c('sidebar'):_vm._e(),_vm._t("default")],2),_c('newFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }